import React from "react";

import { AudioState, Preview } from "@creatomate/preview";
import { MillisecondsField } from "@culturehq/components";
import { MillisecondsFieldValue } from "@culturehq/components/dist/components/form/MillisecondsField";

import { Trans } from "app/utils";
import { timeToNumber } from "components/stories/video-studio/utils";

interface AudioFadeProps {
  activeElement: AudioState;
  fadeProperty: "audio_fade_in" | "audio_fade_out";
  preview: Preview;
}

const AudioFade: React.FC<AudioFadeProps> = ({ activeElement, fadeProperty, preview }) => {
  const handleAudioFadeInChange = async (value: MillisecondsFieldValue) => {
    const audioFadeIn = value || 0;
    await preview.applyModifications({
      [`${activeElement.source.id}.${fadeProperty}`]: audioFadeIn / 100
    });
  };

  return (
    <MillisecondsField
      className="chq-ffd-border"
      min={0}
      name="audio_fade_in"
      onChange={handleAudioFadeInChange}
      value={timeToNumber(activeElement.source[fadeProperty]) * 100}
    >
      <Trans>{fadeProperty === "audio_fade_in" ? "Fade in" : "Fade out"}</Trans>
    </MillisecondsField>
  );
};

export default AudioFade;
